export default __webpack_public_path__ + "static/media/Spiderman2_20.df833bb9.png";